<template>
  <div class="card card-custom">
    <!--begin::Header-->
    <div class="card-header py-5">
      <div class="card-title align-items-start flex-column">
        <h3 class="card-label font-weight-bolder text-dark">Settings</h3>

      </div>
      <div class="card-toolbar">
        <v-btn
            depressed
            :loading="isBusy"
            class="btn btn-primary text-white mr-2"
            @click="createOrUpdate()"
        >
          Save Changes
        </v-btn>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Form-->
    <div v-if="loading">
      <v-skeleton-loader
          v-bind="attrs"
          type="list-item-three-line"
      ></v-skeleton-loader>
      <v-skeleton-loader
          v-bind="attrs"
          type="list-item-three-line"
      ></v-skeleton-loader>
      <v-skeleton-loader
          v-bind="attrs"
          type="list-item-three-line"
      ></v-skeleton-loader>
    </div>
    <div v-else>
      <form class="form">
        <div class="card-body">
          <div class="form-group row">
            <label class="col-xl-3 col-lg-3 col-form-label">Library Membership Expiry</label>
            <div class="col-lg-9 col-xl-6">
              <v-menu
                  ref="menu1"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="user.library_membership_expiry"
                      label="Membership Expiry Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend--inner-icon="mdi-calendar"
                      prepend-icon=""
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      autocomplete="off"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="user.library_membership_expiry"
                    no-title
                    @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </div>
          </div>


          <div class="form-group row">
            <label class="col-xl-3 col-lg-3 col-form-label">Library Notes</label>
            <div class="col-lg-9 col-xl-6">
              <v-textarea
                  v-model="user.library_notes"
                  label="Library Note"
                  outlined
                  dense
              >
              </v-textarea>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-xl-3 col-lg-3 col-form-label">Enable Library</label>
            <div class="col-lg-9 col-xl-6">
              <v-switch
                  v-model="user.enable_library"
                  label="Enable Library"
                  outlined
                  dense
              >
              </v-switch>
            </div>
          </div>

        </div>
      </form>
    </div>
    <!--end::Form-->
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import UserService from "@/core/services/user/UserService";
import ProgramService from "@/core/services/level/program/ProgramService";
import AcademicClassService from "@/core/services/academic-class/AcademicClassService";
import LevelService from "@/core/services/level/LevelService";
import UserEnrollmentService from "@/core/services/user/UserEnrollmentService";
import StudentSettingService from "@/core/services/user/student/StudentSettingService";
import ConfigService from "@/core/services/config/ConfigService";

const settingService = new StudentSettingService();
const userService = new UserService();
const programService = new ProgramService();
const academicClassService = new AcademicClassService();
const levelService = new LevelService();
const enrollmentService = new UserEnrollmentService();
const configService = new ConfigService();
export default {
  name: "student-Settings",
  props: ['user', 'setting'],
  data() {
    return {
      attrs: '',
      isBusy: false,
      loading: false,
      menu: false,
      sizeExceed: false,
      job_types: ["admin", "student", "co-ordinator", "principle"],
      programs: [],
      optional_courses: [],
      selected_optional_courses: [],
      academicYears: [],
      gradesLevels: [],
      academic_classes: [],
      routes: [],
      levels: [],
      levelId: null,
      menudob: false,
      menu2: false,
      menu3: false,
      menu: false,
      validMidasId: false,
      validRegistratioNo: false,
      validSymbolNo: false,
      date: new Date().toISOString().substr(0, 10),
    };
  },

  mounted() {
    // this.userId ? this.getUser(this.userId) : "";
  },
  computed: {
    id() {
      return this.$route.params.id ? this.$route.params.id : false;
    },
    currentUser() {
      return this.$store.getters.currentUser;
    },
    rules() {
      let rule = {
        title: {required},
        first_name: {required},
        last_name: {required},
        type: {required},
      };
      if (!this.id) {
        rule.email = {required};
        rule.phone = {required};
      }
      return rule;
    },
  },
  methods: {
    createOrUpdate() {
      if (this.user.id) {
        this.updateUser();
      }

    },
    updateUser() {
      this.isBusy = true;
      delete this.user.photo;
      userService.update(this.id, this.user).then(response => {
        this.$snotify.success('Update successfully')
        this.isBusy = false;

      })
    },
  },
};
</script>
<style scoped>
.form-control {
  border: none !important;
}
</style>
